import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { myMixin } from './mixin/index.js';
Vue.mixin(myMixin);

import Message from './plugins/message'
Vue.use(Message)

import { api } from './util/api'; // 引入所有的 API
Vue.prototype.$axios = { api };

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import swiperBox from './components/swiper-box.vue'
Vue.component('swiperBox', swiperBox)

Vue.config.productionTip = false

import ImagePreview from './components/image-preview.vue';
Vue.component('ImagePreview', ImagePreview);

import BreadcrumbNav from './components/BreadcrumbNav.vue'
Vue.component('BreadcrumbNav', BreadcrumbNav)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
